'use strict'

export function mimeTypeFilter() {
  return function (mimeType) {
    switch (mimeType) {
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return 'Excel'
      case 'application/pdf':
        return 'PDF'
      case 'application/zip':
        return 'ZIP'
      default:
        return 'TODO'
    }
  }
}



// WEBPACK FOOTER //
// ./app/reports/filters/mime-type.filter.js